export { default } from './EmailCaptureModal.vue';
